import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ChatProps from './ChatProps'

import Messages from './Messages'
import User from './User'
import Toolbar from './Toolbar'
import KendoChatToolbarButton from './KendoChatToolbarButton'

export default {
    props: ChatProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Messages,
        Toolbar,
        User
    ],
    mounted() {
        this._resolveChildren()
        kendo.jQuery(this.$el).kendoChat(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoChat()
        },
        _resolveChildren () {
            this.resolveChildren('toolbarButtons', KendoChatToolbarButton.name)

            if(this.widgetOptions.toolbar &&
                this.widgetOptions.toolbarButtons &&
                this.widgetOptions.toolbarButtons.length) {

                this.widgetOptions.toolbar.buttons = this.widgetOptions.toolbarButtons
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/KendoChatMixin.js